
import { SuperBill, SuperBillControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
    superBill: SuperBill,
    xTENANTID?: string,
}

export const useAddSuperBill = () =>
    useMutationWithLoading(async (params: Params) =>
        new SuperBillControllerApi(getConfigObject()).createSuperBill(
            params.superBill,
            params.xTENANTID
        )
    );